import { isSWSGQLError } from '@/utilities/graphQLClient';

const KNOWN_ERROR_CODES = {
  'PRTFL-019': (tickerSymbol: string) =>
    `You have no shares to sell for this company(${tickerSymbol}). Please add your BUY transaction first.`,
} as const;

const defaultErrorMessage = `Your changes couldn't be saved. Please try again later.`;

export const getErrorMessage = (
  error: unknown,
  { tickerSymbol }: { tickerSymbol: string }
) => {
  if (!isSWSGQLError(error)) return defaultErrorMessage;

  switch (error.code) {
    case 'PRTFL-019':
      return KNOWN_ERROR_CODES['PRTFL-019'](tickerSymbol);
    default:
      return defaultErrorMessage;
  }
};
